"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var wallet_adapter_react_1 = require("@solana/wallet-adapter-react");
var web3_js_1 = require("@solana/web3.js");
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
var spl_token_1 = require("@solana/spl-token");
var axios_1 = __importDefault(require("axios"));
var AssociatedTokenProxy_1 = require("./AssociatedTokenProxy");
var LoadingWidget_1 = require("./LoadingWidget");
var InputError_1 = require("./InputError");
// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css');
var TransactionButton = function (props) {
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(false), canSend = _b[0], setCanSend = _b[1];
    var _c = (0, react_1.useState)(false), hasInvalidData = _c[0], setHasInvalidData = _c[1];
    var _d = (0, react_1.useState)(""), message = _d[0], setMessage = _d[1];
    var connection = (0, wallet_adapter_react_1.useConnection)().connection;
    var _e = (0, wallet_adapter_react_1.useWallet)(), publicKey = _e.publicKey, signTransaction = _e.signTransaction, sendTransaction = _e.sendTransaction;
    var ownerAccount = document.getElementById('owner_account').value;
    var token = document.getElementById('token_account').value;
    var _f = (0, react_1.useState)(), tokenNFT = _f[0], setTokenNFT = _f[1];
    var buyerAccount = document.getElementById('buyer_account').value;
    var _g = (0, react_1.useState)(), toPublicKey = _g[0], setToPublicKey = _g[1];
    (0, react_1.useMemo)(function () {
        if (!publicKey) {
            return;
        }
        if ((publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58()) == ownerAccount) {
            setCanSend(true);
            setHasInvalidData(false);
        }
        else {
            setHasInvalidData(true);
            var errorMessage = "Please connect the NFT owner wallet!";
            if (message == "") {
                setMessage(errorMessage);
            }
            else {
                setMessage(message + "\n" + errorMessage);
            }
        }
    }, [publicKey]);
    (0, react_1.useMemo)(function () {
        try {
            setToPublicKey(new web3_js_1.PublicKey(buyerAccount));
            setTokenNFT(new web3_js_1.PublicKey(token));
        }
        catch (error) {
            setCanSend(false);
            var errorMessage = "Buyer's wallet address or NFT token is invalid!";
            if (message == "") {
                setMessage(errorMessage);
            }
            else {
                setMessage(message + "\n" + errorMessage);
            }
        }
    }, [buyerAccount, token]);
    /**
     * Retrieves the necessary AssociatedTokenAccounts and publicKeys
     * Generates the related Instructions for account creation and token transaction
     * Creates the necessary AssociatedTokenAccounts
     * Sends the token from the AssociatedTokenAccount of the sender to the receiver
     *
     * @constructor
     */
    function SendTransaction() {
        return __awaiter(this, void 0, void 0, function () {
            var fromTokenProxy, toTokenProxy, fromTokenAddress, toTokenAddress, fromTokenAccount, toTokenAccount, transaction, signature, latestBlockHash, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!toPublicKey)
                            return [2 /*return*/];
                        setCanSend(false);
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 10, , 12]);
                        if (!publicKey || !signTransaction)
                            throw new wallet_adapter_base_1.WalletNotConnectedError();
                        // Should be unreachable but just in case
                        if (!canSend)
                            throw new Error("Please connect with an owner account");
                        fromTokenProxy = new AssociatedTokenProxy_1.AssociatedTokenProxy(connection, publicKey, tokenNFT, publicKey);
                        toTokenProxy = new AssociatedTokenProxy_1.AssociatedTokenProxy(connection, publicKey, tokenNFT, toPublicKey);
                        return [4 /*yield*/, fromTokenProxy.getAssociatedTokenPublicKey()];
                    case 2:
                        fromTokenAddress = _a.sent();
                        return [4 /*yield*/, toTokenProxy.getAssociatedTokenPublicKey()];
                    case 3:
                        toTokenAddress = _a.sent();
                        return [4 /*yield*/, fromTokenProxy.getAssociatedTokenAccount(fromTokenAddress)];
                    case 4:
                        fromTokenAccount = _a.sent();
                        return [4 /*yield*/, toTokenProxy.getAssociatedTokenAccount(toTokenAddress)];
                    case 5:
                        toTokenAccount = _a.sent();
                        transaction = new web3_js_1.Transaction();
                        // Add an Instruction for each non-existing AssociatedTokenAccount
                        // The sender should always have such, but just in case
                        if (fromTokenAccount == null) {
                            transaction.add(fromTokenProxy.createATAInstruction(fromTokenAddress));
                        }
                        if (toTokenAccount == null) {
                            transaction.add(toTokenProxy.createATAInstruction(toTokenAddress));
                        }
                        // Add the Token Transfer instruction
                        transaction.add((0, spl_token_1.createTransferInstruction)(fromTokenAddress, // source
                        toTokenAddress, // dest
                        publicKey, 1, [], spl_token_1.TOKEN_PROGRAM_ID));
                        return [4 /*yield*/, sendTransaction(transaction, connection)];
                    case 6:
                        signature = _a.sent();
                        return [4 /*yield*/, connection.getLatestBlockhash()];
                    case 7:
                        latestBlockHash = _a.sent();
                        return [4 /*yield*/, connection.confirmTransaction({
                                blockhash: latestBlockHash.blockhash,
                                lastValidBlockHeight: latestBlockHash.lastValidBlockHeight,
                                signature: signature,
                            })];
                    case 8:
                        _a.sent();
                        // Update the DB with the successful transaction
                        return [4 /*yield*/, axios_1.default.post(window.location.origin + "/nfts/confirm-send/" + props.nftId, {
                                "solana_transaction_id": signature
                            })];
                    case 9:
                        // Update the DB with the successful transaction
                        _a.sent();
                        window.location.replace(window.location.origin + "/nfts");
                        return [3 /*break*/, 12];
                    case 10:
                        error_1 = _a.sent();
                        // Prepare the error toast to be shown after reload
                        return [4 /*yield*/, axios_1.default.post(window.location.origin + '/show-error-toast', {
                                message: "Transaction failed " + error_1.message
                            })];
                    case 11:
                        // Prepare the error toast to be shown after reload
                        _a.sent();
                        window.location.reload();
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("input", { className: "btn bg-gradient-success w-100", type: "button", value: "Send to Buyer", onClick: SendTransaction, disabled: !canSend }),
        hasInvalidData ? react_1.default.createElement(InputError_1.InputError, { message: message }) : null,
        loading ? react_1.default.createElement(LoadingWidget_1.LoadingWidget, null) : null));
};
exports.default = TransactionButton;
